import * as React from "react";
import type { SVGProps } from "react";
const SvgSun02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M12 3.062V2.4m0 19.2v-.662M20.938 12h.662M2.4 12h.662m15.259-6.32.468-.468M5.21 18.788l.468-.468m12.642 0 .468.468M5.21 5.212l.468.468m11.605 6.284a5.296 5.296 0 1 1-10.593 0 5.296 5.296 0 0 1 10.593 0Z"
    />
  </svg>
);
export default SvgSun02;
